/**
 * Construct a URL for static assets, prepending CDN URL in production.
 *
 * @param cdnUrl - The CDN base URL (empty string in development)
 * @param path - The asset path (e.g., '/img/hero-landing.webp')
 * @returns The full asset URL
 */
export function assetUrl(cdnUrl: string, path: string): string {
  if (!cdnUrl) {
    return path;
  }
  return cdnUrl + path;
}
